module.exports = require("core-js/library/fn/object/define-property");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/object/define-property.js
 ** module id = 647
 ** module chunks = 0
 **/